import { Navigate, useLocation } from 'react-router-dom';

/**
 * An account page reached while signed out: sign in, then land on the page that was asked for.
 *
 * The signed-out container declares no catch-all, so a path only `User.js` serves rendered the
 * application shell and nothing in it. The Password Changed and New Device emails both send a fan to
 * `/settings` to review their account, and a fan reading their email is usually not signed in on
 * that browser, so the button showed a blank page. `?redirect=` is what the login screen already
 * reads (email, Google and Facebook sign-in alike) to choose where to go once the fan is in.
 */
const SignInFirst = () => {
  const { pathname, search } = useLocation();

  return <Navigate to={`/login?redirect=${encodeURIComponent(pathname + search)}`} replace />;
};

export default SignInFirst;
